<script lang="ts">
  import ListAlert from '$shared/atoms/ListAlert/ListAlert.svelte';
  import FlexibleDataModelType from '$provider/lib/apis/models/FlexibleDataModelType';
  import { toHeaderCase } from 'js-convert-case';
  import Form from './Form.svelte';
  import Table from './Table.svelte';

  let { data } = $props();
</script>

<div class="complex-obj-section">
  <!-- If array -->
  {#if data && Array.isArray(data)}
    {#each data as item, index}
      <div class="section-i">
        {#if typeof item === 'string'}
          <div data-cy={`section-${index}`} class="text">{item}</div>
        {:else if item?.type === FlexibleDataModelType.Form}
          <div class="comp">
            <Form data={item?.data} />
          </div>
        {:else if item?.type === FlexibleDataModelType.Table}
          <div class="comp">
            <Table data={item?.data} />
          </div>
        {:else if item?.alert}
          <div class="alert">
            <ListAlert alert={item?.alert} />
          </div>
        {:else}
          <div class="invalid">Invalid object type</div>
        {/if}
      </div>
    {:else}
      <div class="invalid">No items found as section array</div>
    {/each}
    <!-- If object -->
  {:else if typeof data === 'object'}
    {#each Object.entries(data) as [key, value]}
      <div class="section-i">
        <div data-cy={`${key}-k`} class="key">{toHeaderCase(key)}</div>
        {#if value}
          <div class="value">
            {#if typeof value === 'string'}
              <div data-cy={`${key}-v`} class="text">{value}</div>
            {:else if value?.type === FlexibleDataModelType.Form}
              <div class="comp">
                <Form isChild data={value?.data} />
              </div>
            {:else if value?.type === FlexibleDataModelType.Table}
              <div class="comp">
                <Table isChild data={value?.data} />
              </div>
            {:else if value?.alert}
              <div class="alert">
                <ListAlert alert={value?.alert} />
              </div>
            {:else}
              <div class="invalid">Invalid object type</div>
            {/if}
          </div>
        {/if}
      </div>
    {:else}
      <div class="invalid">No items found as section object</div>
    {/each}
  {:else}
    <div class="invalid">Invalid type section object</div>
  {/if}
</div>

<style>
  .section-i {
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    padding: 12px 16px;
    line-height: 20px;
  }
  .section-i .key {
    width: 150px;
    flex-shrink: 0;
    font-weight: bold;
    margin-right: 0;
    width: auto;
    color: var(--black);
  }
  .section-i .value {
    width: 100%;
  }
  .section-i .comp {
    padding-left: 8px;
  }
</style>
